import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('reporterInformations')
export class ReporterInformation {
  @JsonProperty('gender', String, true)
  public gender = '';

  @JsonProperty('name', String, true)
  public name: string | null = null;

  @JsonProperty('birthname', String, true)
  public birthname = '';

  @JsonProperty('firstname', String, true)
  public firstname = '';

  @JsonProperty('relationshipWithDeceased', String, true)
  public relationshipWithDeceased = '';

  @JsonProperty('address', String, true)
  public address = '';

  @JsonProperty('complementaryAddress', String, true)
  public complementaryAddress = '';

  @JsonProperty('zipcode', String, true)
  public zipcode = '';

  @JsonProperty('city', String, true)
  public city = '';

  @JsonProperty('country', String, true)
  public country = '';

  @JsonProperty('email', String, true)
  public email = '';

  @JsonProperty('emailConfirmation', String, true)
  public emailConfirmation = '';

  @JsonProperty('phoneNumber', String, true)
  public phoneNumber = '';

  @JsonProperty('commentary', String, true)
  public commentary = '';
}
